import { render } from "./DelayApplyOperationRecord.vue?vue&type=template&id=6f27088f&scoped=true"
import script from "./DelayApplyOperationRecord.vue?vue&type=script&lang=js"
export * from "./DelayApplyOperationRecord.vue?vue&type=script&lang=js"

import "./DelayApplyOperationRecord.vue?vue&type=style&index=0&id=6f27088f&lang=less&scoped=true"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f27088f"]])

export default __exports__